import React from 'react'


export default class Obs extends React.Component {
    textArea() {
        let nome = this.props.nome
        if (nome == "matObs") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.matObs} />
        }
        else if (nome == "parametroObs") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.parametroObs} />
        }
        else if (nome == "obs6") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.obs6} />
        }
        else if (nome == "obs7") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.obs7} />
        }
        else if (nome == "obs8") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.obs8} />
        }
        else if (nome == "obs9") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.obs9} />
        }
        else if (nome == "fechadoObs") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.fechadoObs} />
        }
        else if (nome == "outrosDados") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.outrosDados} />
        }
        else if (nome == "orientacoes") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.orientacoes} />
        }
        else if (nome == "aotaObs") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.aotaObs} />
        }
        else if (nome == "obsProntuario") {
            return <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.obsProntuario} />
        }
        else if (nome == "relato") {
            return (
                <React.Fragment>
                    <div className="mt-5 font-weight-bold text-left">
                        {this.props.numero} -  RELATO DA SITUAÇÃO ENCONTRADA:
                    </div>
                    <textarea type="textarea" rows="3" className="form-control" name={nome} {...this.props} value={this.props.value.relato} />
                </React.Fragment>
            )
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="form-group row mt-3">
                    {this.renderOption()}
                </div>
            </React.Fragment>
        )
    }

    renderOption() {
        if (this.props.nome == "relato") {
            return (
                <div className="col-12">
                    {this.textArea()}
                </div>
            )
        } else {
            return (
                <React.Fragment>
                    <label className="col-12 text-left">Observações:</label>
                    <div className="col-12">
                        {this.textArea()}
                    </div>
                </React.Fragment>
            )
        }
    }
}